enum Action {
  SET_ITEM = 'setItem',
  CLEAR_ITEM = 'clearItem',
}

export default Action;
